import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetHtmlDocumentTemplateDocument,
  GetHtmlDocumentTemplateQuery,
  GetHtmlDocumentTemplateQueryVariables,
  GetHtmlDocumentTemplatesDocument,
  GetHtmlDocumentTemplatesQuery,
  GetHtmlDocumentTemplatesQueryVariables,
  HtmlDocumentTemplateFieldsFragment
} from '~/api/graphql';

export const getHtmlDocumentTemplates = async () =>
  queryData<
    GetHtmlDocumentTemplatesQuery,
    GetHtmlDocumentTemplatesQueryVariables,
    HtmlDocumentTemplateFieldsFragment[]
  >(
    client,
    { query: GetHtmlDocumentTemplatesDocument },
    (data) => data?.htmlDocumentTemplates || []
  );

export const getHtmlDocumentTemplate = async (id: string) =>
  queryData<
    GetHtmlDocumentTemplateQuery,
    GetHtmlDocumentTemplateQueryVariables,
    HtmlDocumentTemplateFieldsFragment
  >(
    client,
    { query: GetHtmlDocumentTemplateDocument, variables: { id: id } },
    (data) => data?.htmlDocumentTemplate
  );

export const loadHtmlDocumentTemplates: LoaderFunction = () =>
  loadQuery(getHtmlDocumentTemplates(), {
    suppressAuthErrors: true
  });

export const loadHtmlDocumentTemplate: LoaderFunction = ({ params }) =>
  loadQuery(getHtmlDocumentTemplate(params.id || ''));
